module.exports = __webpack_public_path__ + "img/bg-1.9e99597c.jpg";